import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import "./LoginPage.css";
import { Card } from "react-bootstrap";
import Login from "./Login/Login";
import ForgotPassword from "./ForgotPassword/ForgotPassword";
import ForgotPasswordNext from "./ForgotPassword/ForgotPasswordNext";
import Login2FA from "./Login/Login2FA";

export default function LoginPage() {
  return (
    <div className="login-page-container">
      <div className="login-container">
        <Card className="login-card">
          <Card.Img variant="top" src="logo.png" className="login-logo" />
          <HashRouter>
            <Routes>
              <Route path="/" element={<Navigate replace to="/login" />} />
              <Route path="/login" element={<Login />} />
              <Route path="/login-2fa" element={<Login2FA />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/forgot-password-next"
                element={<ForgotPasswordNext />}
              />
            </Routes>
          </HashRouter>
        </Card>
      </div>
      <p className="copyright">Copyright &copy; 2022 Spacelink Inc.</p>
    </div>
  );
}
